import { http, pagination } from 'utils'
import { make } from 'vuex-pathify'
import pendingGarments from './delivery-runs/pending-garments'

const initialDeliveryRunState = () => ({
  stops: []
})

export default {
  namespaced: true,

  modules: {
    pendingGarments
  },

  state: {
    deliveryRuns: [],
    deliveryRun: initialDeliveryRunState(),
    meta: null,
    triggers: {
      updateMapDirections: false,
      updateDeliveryRunStopOrder: false
    },
    updateStopOrder: false
  },

  getters: {
    deliveryRunExists: (state) => state.deliveryRun.id !== undefined && state.deliveryRun.id !== null
  },

  actions: {
    ...make.actions('deliveryRuns'),
    ...make.actions('deliveryRun'),
    ...make.actions('meta'),
    ...make.actions('triggers'),

    async getDeliveryRun ({ dispatch }, id) {
      const response = await http.get(`delivery-runs/${id}`)

      dispatch('setDeliveryRun', response.data.data)

      return response
    },

    resetDeliveryRun ({ dispatch }) {
      dispatch('setDeliveryRun', initialDeliveryRunState())
    },

    startDeliveryRun (store, id) {
      return http.post(`delivery-runs/${id}/start`)
    },

    async completeDeliveryRun ({ dispatch }, id) {
      const response = await http.post(`delivery-runs/${id}/complete`)

      dispatch('setDeliveryRun', response.data.data)
    },
    refreshDeliveryRun (store, id) {
      return http.post(`delivery-runs/${id}/refresh`)
    },

    deleteDeliveryRun (store, id) {
      return http.delete(`delivery-runs/${id}`)
    },

    updateDeliveryRunDriver ({ dispatch }, { id, driver }) {
      return http.put(`delivery-runs/${id}/driver`, {
        driver_id: driver
      })
    },

    async updateDeliveryRunStop ({ dispatch }, { id, stop }) {
      const response = await http.put(`delivery-runs/${id}/stops/${stop.id}`, stop)

      dispatch('setDeliveryRunStop', response.data.data)

      return response.data.meta
    },

    deleteDeliveryRunStop (store, { id, stop }) {
      return http.delete(`delivery-runs/${id}/stops/${stop.id}`)
    },

    updateDeliveryRunStopOrder (store, { id, stops }) {
      return http.put(`delivery-runs/${id}/stops/order`, { stops })
    },

    resetDeliveryRuns ({ dispatch }) {
      dispatch('setDeliveryRuns', [])
      dispatch('setMeta', null)
    },

    async getDeliveryRuns ({ state, dispatch }, params = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          throw new Error('No more results.')
        }

        params.page = state.meta.current_page + 1
      }

      const response = await http.get('delivery-runs', { params })

      dispatch('addDeliveryRuns', response.data.data)
      dispatch('setMeta', response.data.meta)

      return response
    },

    storeDeliveryRun ({ commit }, { stations, runs, efficiency, assignAll }) {
      return http.post('delivery-runs', { stations, runs, efficiency, assignAll })
    },

    storeCourierDeliveryRun ({ commit }, { stations }) {
      return http.post('delivery-runs/courier', { stations })
    },

    addDeliveryRuns ({ commit }, deliveryRuns) {
      commit('ADD_DELIVERY_RUNS', deliveryRuns)
    },

    setDeliveryRunStop ({ commit }, stop) {
      commit('SET_DELIVERY_RUN_STOP', stop)
    },

    async updateDeliveryRunStopContainers ({ dispatch }, { deliveryRun, stop, payload }) {
      const response = await http.put(`delivery-runs/${deliveryRun.id}/stops/${stop.id}/containers`, payload)

      dispatch('setDeliveryRunStop', response.data.data)
    },

    async printDeliveryRunStopConsignment ({ dispatch }, { deliveryRun, stop }) {
      await http.post(`delivery-runs/${deliveryRun.id}/stops/${stop.id}/print`)
    }
  },

  mutations: {
    ...make.mutations('deliveryRuns'),
    ...make.mutations('deliveryRun'),
    ...make.mutations('meta'),
    ...make.mutations('triggers'),

    ADD_DELIVERY_RUNS (state, deliveryRuns) {
      state.deliveryRuns = state.deliveryRuns.concat(deliveryRuns)
    },

    SET_DELIVERY_RUN_STOP (state, stop) {
      const index = state.deliveryRun.stops.findIndex(({ id }) => id === stop.id)

      if (index !== -1) {
        state.deliveryRun.stops.splice(index, 1, stop)
      }
    }
  }
}
